import Component from './Component';
import { hideMessageboxModal, TripPlannerMode } from '../lib/TripPlannerHelper';
import { startTokenOrSignin } from '../lib/OidcHelper';


var thisComponent = null;

export default class ModalMessagebox extends Component {
  load() {
    this.init();
    super.load();
    thisComponent = this;
  }

  init() {
    this.exitOnBackdropClick('#msgboxModalModes');
    this.exitOnBackdropClick('#msgboxModalUpsell');

    this.setupModesMsgbox();
    this.setupUpsellMsgbox();
  }

  exitOnBackdropClick(msgboxId) {
    const modalMsgbox = $(msgboxId);
    modalMsgbox.on('click', (e) => {
      if (e.target === modalMsgbox[0]) {
        hideMessageboxModal(msgboxId);
      }
    });
  }

  setupModesMsgbox() {
    this.injectModesMsgboxHtml();

    const createButton = $('.js-create-account');
    const trySandboxButton = $('.js-try-sandbox');
    const loginButton = $('.js-login-modes');

    // Check local storage for last message box answer
    createButton.on('click', () => {
      localStorage.setItem('tpMode', 'login');
      hideMessageboxModal('#msgboxModalModes');
      // Go to register page
      // console.log('msgbox createButton');
    });
    trySandboxButton.on('click', () => {
      localStorage.setItem('tpMode', TripPlannerMode.sandbox);
      hideMessageboxModal('#msgboxModalModes');
      // console.log('msgbox sandboxButton');
    });
    loginButton.on('click', (e) => {
      e.preventDefault();
      console.log('"open-tripplan-modal" > modal > login Button clicked');
      localStorage.setItem('tpMode', 'login');
      hideMessageboxModal('#msgboxModalModes');
      // console.log('msgbox loginButton');
      (async () => {
        await startTokenOrSignin(); // should trigger a login redirect
      })();
    });
  }

  getSpinnerHtml() {
    return `
      <div id="modal-messagebox-spinner" class="modal-messagebox__spinner">
        <svg class="modal-messagebox__spinner-circle" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
  }

  injectModesMsgboxHtml() {
    const modalMsgbox = $('#msgbox-modes-container');
    const registerUrl = modalMsgbox.attr('data-register-url');
    const loginUrl = modalMsgbox.attr('data-login-url');

    modalMsgbox.html(`
      <div id="modal-modes-container">
        <div class="modal-messagebox__close">
          <a href="#" class="modal-messagebox__close-link">
            <img src="/static/images/i_times_light.svg" class="modal-messagebox__close-icon">
          </a>
        </div>
        <div class="modal-messagebox__content">
          <div class="modal-messagebox__heading">FIRST TIME USING OUR TRIP PLANNER?</div>
          <div class="modal-messagebox__message">
            <p>Unlock access to the Trip Planner and more by creating a southaustralia.com account.</p>
            <ul class="modal-messagebox__listing--tick">
              <li>Create, save & share trips</li>
              <li>Favourite products</li>
              <li>Manage your website & email preferences</li>
            </ul>
          </div>
          <div class="modal-messagebox__buttons">
            <a href="${registerUrl}" class="modal-messagebox__button--primary js-create-account">SIGN UP</a>
            <a href="${loginUrl}" class="modal-messagebox__button--secondary js-login-modes">LOG IN</a>
            <a href="#" class="modal-messagebox__button--secondary js-try-sandbox">TRY WITHOUT ACCOUNT</a>
          </div>
        </div>
      </div>
    ` + this.getSpinnerHtml());

    $('.modal-messagebox__close-link').on('click', (e) => {
      hideMessageboxModal('#msgboxModalModes');
    });
  }

  setupUpsellMsgbox() {
    this.injectUpsellMsgboxHtml();

    const createButton = $('.js-create-account');
    const loginButton = $('.js-login');
    const backButton = $('.js-close');

    // Check local storage for last message box answer
    createButton.on('click', () => {
      localStorage.setItem('tpMode', 'login');
      hideMessageboxModal('#msgboxModalUpsell');
      // Go to register page
      // console.log('msgbox createButton');
    });
    loginButton.on('click', (e) => {
      e.preventDefault();
      console.log('"js-prefcentre-head-favourites" > modal > login link clicked');
      localStorage.setItem('tpMode', 'login');
      hideMessageboxModal('#msgboxModalUpsell');
      // When user has attempted to go to favourites, is presented modal with log in button, and clicks it.
      const redirectPage = '/preference-centre#favourites';
      // sessionStorage.setItem('redirectPage', redirectPage); // set in a later function
      // console.log('msgbox loginButton');
      (async () => {
        await startTokenOrSignin(redirectPage); // should trigger a login redirect
      })();
    });
    backButton.on('click', (e) => {
      e.preventDefault();
      hideMessageboxModal('#msgboxModalUpsell');
    });
  }

  injectUpsellMsgboxHtml() {
    const modalMsgbox = $('#msgbox-upsell-container');
    const registerUrl = modalMsgbox.attr('data-register-url');
    const loginUrl = modalMsgbox.attr('data-login-url');

    modalMsgbox.html(`
      <div id="msgbox-modal-upsell-container">
        <div class="modal-messagebox__close">
          <a href="#" class="modal-messagebox__close-link">
            <img src="/static/images/i_times_light.svg" class="modal-messagebox__close-icon">
          </a>
        </div>
        <div class="modal-messagebox__content">
          <div class="modal-messagebox__heading">WANT TO SAVE YOUR FAVOURITE PRODUCTS?</div>
          <div class="modal-messagebox__message">
            <p>Log in or sign up for a southaustralia.com account to save your favourite products and more.</p>
            <ul class="modal-messagebox__listing--tick">
              <li>Trip Planner tool</li>
              <li>Favourite products</li>
              <li>Manage your website & email preferences</li>
            </ul>
          </div>
          <div class="modal-messagebox__buttons">
            <a href="${registerUrl}" class="modal-messagebox__button--primary js-create-account">SIGN UP</a>
            <a href="${loginUrl}" class="modal-messagebox__button--secondary js-login">LOG IN</a>
            <a href="#" class="modal-messagebox__button--third js-close">Back</a>
          </div>
        </div>
      </div>
    `);

    $('.modal-messagebox__close-link').on('click', (e) => {
      e.preventDefault();
      hideMessageboxModal('#msgboxModalUpsell');
    });
  }
}
